const SPORT_POSITIONS = {
    soccer: ["Defender", "Midfielder", "Forward", "Goalkeeper"],
    basketball: ["BasketballGuard", "BasketballForward", "BasketballCenter"],
    football: [
      "FootballQuarterBack",
      "FootballWideReceiver",
      "FootballTightEnd",
      "FootballRunningBack",
    ],
    hockey: [
      "HockeyCenter",
      "HockeyDefenseman",
      "HockeyRightWing",
      "HockeyLeftWing",
    ],
    rugby: [
      "RugbyFullback",
      "RugbyCentre",
      "RugbyWing",
      "RugbyHalves",
      "RugbyHoocker",
      "RugbyMiddleForward",
      "RugbyEdgeForward",
    ],
    australian_football:["Defender", "Midfielder", "Forward", "AustralianFootballRuck"],
    cricket: ["CricketBowler", "CricketBatsmen", "AllRounder"]
  };
export default SPORT_POSITIONS;